export default __webpack_public_path__ + "static/media/adithya.8f7a72a1.jpg";